import { render } from "./LoopMetricsDocked.vue?vue&type=template&id=b35d23e6&scoped=true"
import script from "./LoopMetricsDocked.vue?vue&type=script&lang=js"
export * from "./LoopMetricsDocked.vue?vue&type=script&lang=js"

import "./LoopMetricsDocked.vue?vue&type=style&index=0&id=b35d23e6&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35d23e6"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QInnerLoading});
